const CURRENCY_FORMATTER = 100;

export function currencyFormatter(value: any, formatter: boolean = true) {
  if (!Number(value)) return '';
  const amount = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(formatter ? value / CURRENCY_FORMATTER : value);

  return amount;
}

export function formatCurrencyPtBr(value: string | number | undefined) {
  if (!value) return `R$ 0,0`;
  return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
}
